module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/star-solid-34.339a1ee59f804128.png"+" 34w",
        images: [{path: "https://static.sniffspot.com/packs/img/star-solid-34.339a1ee59f804128.png",width: 34,height: 33}],
        src: "https://static.sniffspot.com/packs/img/star-solid-34.339a1ee59f804128.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/star-solid-34.339a1ee59f804128.png"},
        
        width: 34,
        height: 33
      }